import { useEffect } from "react";
import { useStytchSession } from "@stytch/react";
import * as Sentry from "@sentry/react";
import { useFetchUser } from "../../hooks/useFetchUser";
import { useMerchant } from "../../hooks/useMerchant";
import { identifyUser } from "../../helpers/posthog";

export const UserIdentification = (): JSX.Element => {
  const { session } = useStytchSession();
  const { user } = useFetchUser();
  const { merchant } = useMerchant();

  useEffect(() => {
    Sentry.setUser({ id: session?.user_id, email: user?.email });
    if (session?.user_id && user && merchant?.id)
      identifyUser(session.user_id, user, merchant.id);
  }, [session?.user_id, user, merchant?.id]);

  return <></>;
};
